import React from 'react';
// import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components';
// import Img from 'gatsby-image'
import KiwiAd from '../../../Ads/Kiwi';

class Ads extends React.Component {
  render() {
    return (
      <Container>
        <Wrapper>
          {/* <a
            href="http://goldengirls.ru?utm_source=trendymoscow&utm_medium=banner&utm_campaign=media"
            rel="nofollow"
            target="_blank"
          >
            <BannerWrapper>
              <img
                src="https://res.cloudinary.com/dgjpupozi/image/upload/v1559150711/SIDEBAR/golden-girls.jpg"
                alt="moscow in russia"
              />
            </BannerWrapper>
          </a> */}
          <a href="http://en.5massage.ru/" rel="nofollow" target="_blank">
            <BannerWrapper>
              <img
                src="https://res.cloudinary.com/dgjpupozi/image/upload/v1559150711/SIDEBAR/vanilia.jpg"
                alt="moscow"
              />
            </BannerWrapper>
          </a>
          <KiwiAd />
        </Wrapper>
      </Container>
    );
  }
}

const Container = styled.div`
  @media (max-width: 600px) {
    margin-top: 20px;
  }
`;
const Wrapper = styled.div`
  a {
    max-width: 240px;
    margin: 0 auto 4rem;
    display: block;
  }
`;
const BannerWrapper = styled.div``;

export default Ads;

// <a href="http://goldengirls.ru/english/" rel="nofollow" target="_blank">
// <BannerWrapper><Img fluid={ data.image1.childImageSharp.fluid } /></BannerWrapper>
// </a>
// <a href="http://en.5massage.ru/" rel="nofollow" target="_blank">
// <BannerWrapper><Img fluid={ data.image2.childImageSharp.fluid } /></BannerWrapper>
// </a>

// const sideFrontBannerQuery = graphql`
//   query sideFrontBannerQuery {
//     image1: file(relativePath: { eq: "banners/golden-girls.jpg" }) {
//       ...sideImage
//     }
//     image2: file(relativePath: { eq: "banners/vanilia.jpg" }) {
//       ...sideImage
//     }
// }
// `

// export const sideImage = graphql`
//   fragment sideImage on File {
//     childImageSharp {
//       fluid(maxWidth: 240, maxHeight: 400, quality: 100 ) {
//         ...GatsbyImageSharpFluid
//       }
//     }
//   }
// `
